import React from 'react';
import Image from 'next/legacy/image';
import { Popover } from '@headlessui/react';
import classnames from 'classnames';

import rightArrow from '../../../public/images/arrow-rightV2.svg';

type PopoverSearchPageProps = {
  name: string;
  buttonClassName?: string;
  classnamesFront?: string;
  arrowClasses?: string;
  render?: any;
};

const PopoverSearchPageV2: React.FC<PopoverSearchPageProps> = ({
  name,
  buttonClassName,
  render,
  classnamesFront,
  arrowClasses,
}) => {
  return (
    <Popover as="div" className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button className="outline-none">
            <div
              className={`flex text-black justify-between !pt-[10px] !pb-[10px] lg:!pt-[9px] lg:!pb-[13px] items-center px-[10px] xl:px-[17px] xxl:px-3 ${buttonClassName}`}
            >
              <div
                className={`flex mr-3 items-center align-middle xxl:pt-0 s:text-16-16-0.3 xl:text-14-20-0.3 whitespace-nowrap flex-1 min-w-0 ${classnamesFront} text-left`}
              >
                <span className="w-[62px]">{name}</span>
              </div>
              <div className={`flex-shrink-0 ${arrowClasses} `}>
                <Image
                  className={`transition duration-300 !pt-[1px] mr-4 ${classnames(
                    {
                      'transform rotate-90': open,
                    }
                  )}`}
                  src={rightArrow}
                  width={14}
                  height={14}
                  alt="view"
                />
              </div>
            </div>
          </Popover.Button>
          {render({ close })}
        </>
      )}
    </Popover>
  );
};

export default PopoverSearchPageV2;
